import * as THREE from 'three';
import { RENDER } from '../config';

/**
 * WebGLRenderer를 만들고 XR을 켠 뒤 캔버스를 body에 붙인다.
 *
 * 색 파이프라인 메모: 원본 프로토타입은 three r128이었고, 당시 기본값은
 * 색관리 OFF + LinearEncoding 출력이었다. 최신 three는 ColorManagement ON +
 * sRGB 출력이 기본이라 같은 셰이더라도 골드 톤이 밝게 변한다. 마이그레이션
 * 충실도를 위해 r128 파이프라인을 그대로 재현한다. (모던 색관리 전환은 별도 단계로.)
 */
export function createRenderer(): THREE.WebGLRenderer {
  THREE.ColorManagement.enabled = false;

  const renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, RENDER.maxPixelRatio));
  renderer.outputColorSpace = THREE.LinearSRGBColorSpace; // r128 LinearEncoding 동등
  renderer.xr.enabled = true;

  document.body.appendChild(renderer.domElement);
  return renderer;
}
